<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Báo cáo tổng hợp thu/chi</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-primary btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu </button>
                    <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                        <i class="fas fa-file-excel"></i> Xuất excel 
                    </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky">
                            <option value="1,2,3,4">Tất cả</option>
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc">
                            <option value="">Chọn</option>
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                        <div class="col-md-2">
                            <label>Từ ngày</label>
                            <input type="date" class="form-control" formControlName="Tu_ngay">
                        </div>
                        <div class="col-md-2">
                            <label>Đến ngày</label>
                            <input type="date" class="form-control" formControlName="Den_ngay">
                        </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-sm " style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Khoản thu </th>
                            <th>Số tiền phải thu</th>
                            <th>Số tiền đã thu </th>
                            <th>Số tiền đã chi </th>
                            <th>Số tiền còn phải thu </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataTable; let i = index">
                            <td *ngIf="!((dataTable.length - 1) == i)">{{item.Ten_khoan_thu}}</td>
                            <td *ngIf="!((dataTable.length - 1) == i)">{{item.So_tien_phai_thu | number}}</td>
                            <td *ngIf="!((dataTable.length - 1) == i)">{{item.So_tien_da_thu | number }}</td>
                            <td *ngIf="!((dataTable.length - 1) == i)">{{item.So_tien_da_chi | number}}</td>
                            <td *ngIf="!((dataTable.length - 1) == i)">{{item.So_tien_con_phai_thu | number}}</td>
                            <td class="font-weight-bold" *ngIf="(dataTable.length - 1) == i">{{item.Ten_khoan_thu}}</td>
                            <td class="font-weight-bold" *ngIf="(dataTable.length - 1) == i">{{item.So_tien_phai_thu | number}}</td>
                            <td class="font-weight-bold" *ngIf="(dataTable.length - 1) == i">{{item.So_tien_da_thu | number }}</td>
                            <td class="font-weight-bold"*ngIf="(dataTable.length - 1) == i">{{item.So_tien_da_chi | number}}</td>
                            <td class="font-weight-bold" *ngIf="(dataTable.length - 1) == i">{{item.So_tien_con_phai_thu | number}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>